import React from "react";
import { FormFeedback, FormGroup, Input, InputProps, Label } from "reactstrap";

type Props = {
  label?: string;
  errorMessage?: string;
  register?: any;
} & InputProps;
export function BaseInput({
  label,
  errorMessage,
  type = "text",
  register,
  ...rest
}: Props) {
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);
  return (
    <FormGroup>
      {label ? <Label className="form-label">{label}</Label> : null}
      <div className="input-group auth-pass-inputgroup">
        <Input
          className="form-control"
          type={type !== "password" ? type : show ? "text" : "password"}
          {...rest}
        />

        {type === "password" ? (
          <button
            onClick={handleClick}
            className="btn btn-light "
            type="button"
            id="password-addon"
          >
            {!show ? (
              <i className="mdi mdi-eye-outline"></i>
            ) : (
              <i className="mdi mdi-eye-off-outline"></i>
            )}
          </button>
        ) : null}
        {errorMessage ? (
          <FormFeedback invalid>{errorMessage}</FormFeedback>
        ) : null}
      </div>
    </FormGroup>
  );
}
